import { IconProps } from './IconProps';

export const CartAdd = ({
  className,
  style,
  fill = 'black',
  width = 10,
  height = 10,
}: {
  className?: string;
  style?: Record<string, unknown>;
  fill?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      className={className}
      style={style}
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 1V9"
        stroke={fill ?? 'black'}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1 5H9"
        stroke={fill ?? 'black'}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

